import React from 'react';
import { Checkbox } from 'antd';

import { views } from '../constants/event';
import { retentionViews } from '../constants/retention';
import { grandTotal } from './chart/ChartManagementFeatures/showChartFeatures';
import CustomDropdownMenu from '../components/common/CustomDropdownMenu';

const ColumnChartFeaturesMenu = ({
  view,
  isRetention,
  columnChartSorting,
  calcTotal,
  toggleAdaptive,
  toggleGrandTotal,
  adaptive,
  toggleTrendLine,
  trendLine,
  toggleAverageLine,
  averageLine,
  toggleMedianLine,
  medianLine,
  showCumulative,
  toggleCumulative,
  cumulative,
}) => {
  return (
    <CustomDropdownMenu>
      {view === views.COLUMN_CHART && !isRetention && (
        <li key="grandTotal">
          <Checkbox onChange={(e) => toggleGrandTotal(e, columnChartSorting)} checked={calcTotal}>
            {grandTotal}
          </Checkbox>
        </li>
      )}
      {(view === views.CHART || view === retentionViews.CHART_BY_DATE) && (
        <li key="adaptive">
          <Checkbox onChange={toggleAdaptive} checked={adaptive}>
            Adaptive
          </Checkbox>
        </li>
      )}
      {(view === views.CHART || view === retentionViews.CHART_BY_DATE) && (
        <li key="trend">
          <Checkbox onChange={toggleTrendLine} checked={trendLine}>
            Trend
          </Checkbox>
        </li>
      )}
      <li key="average">
        <Checkbox onChange={toggleAverageLine} checked={averageLine}>
          Average
        </Checkbox>
      </li>
      <li key="median">
        <Checkbox onChange={toggleMedianLine} checked={medianLine}>
          Median
        </Checkbox>
      </li>
      {showCumulative && (
        <li key="cumulative">
          <Checkbox onChange={toggleCumulative} checked={cumulative}>
            Cumulative
          </Checkbox>
        </li>
      )}
    </CustomDropdownMenu>
  );
};

export default ColumnChartFeaturesMenu;
